import { rem } from "@mantine/core";
import styled from "styled-components";

import { StyledLabTabTable } from "../LabTab/LabTab.styled";


export const StyledConsultationTabTable = styled(StyledLabTabTable)`
  tr {
    height: ${rem(60)};
  }
  th,
  td {
    padding: 0.8em 5em 0.8em 0;
    width: auto !important;
    min-width: ${rem(60)};

    &:first-child {
      padding-right: 0.5em !important;
    }
  }
`;
